import styled from 'styled-components';
export var NoComponentSettingsWrapper = styled.div.withConfig({
  displayName: "ComponentSettingsNotAvailablestyles__NoComponentSettingsWrapper",
  componentId: "keen-widget-settings__sc-1jjnoyj-0"
})(["&&&{height:100%;display:flex;align-items:center;justify-content:center;}"]);